export const purchaseHeaders = [
    'Purchase id *',
    'Reference id (Order No.)',
    'Description (Event Name) *',
    'Description 2 (Event Venue)',
    'Class 1 (Section, category) *',
    'Class 2 (Row, sub-category) *',
    'Class 3 (Seat, sub-detail) *',
    'Purchase Price *',
    'Expiration date (Event date) *',
    'Purchase date *',
    'Purchaser email',
];

export const requiredPurchaseHeaders = purchaseHeaders.filter((header) => header.includes('*'));
